// import React from 'react';
// import { FiSearch, FiPlusCircle, FiBarChart2, FiArrowRight } from 'react-icons/fi';
// import { IoSparkles } from 'react-icons/io5';
// import { Link } from 'react-router-dom';

// const ActionCards = () => {
//   return (
//     <section className="grid grid-cols-1 md:grid-cols-3 gap-4">
//       <div className="text-left bg-white p-6 rounded-2xl shadow-lg border border-gray-100">
//         <h3 className="font-bold mph-primary flex items-center gap-2"><FiSearch className="mph-primary" /> 
//         <span className='text-sm font-semibold mph-light mph-primary px-3 py-1 rounded-full'>Smart Candidate Search</span></h3>
//         <Link 
//         to="/candidates"style={{ width: 'fit-content' }} className="flex gap-2 items-center bg-gradient text-white text-sm font-semibold px-4 py-2 rounded-full mt-4 hover:profiler-bg">
//           <IoSparkles />Search Candidates<FiArrowRight />
//           </Link>
//         <p className="text-xs text-gray-500 mt-3">Find the perfect candidates using AI-powered matching algorithms. Search by skills, experience, location, and more.</p>
//         <div className="flex items-center gap-3 mt-2">
//           {/* Avatar Stack Container */}
//           <div className="flex -space-x-3">
//             <img
//               className="w-8 h-8 rounded-full border-2 border-white"
//               src="https://randomuser.me/api/portraits/women/68.jpg"
//               alt="User 1"
//             />
//             <img
//               className="w-8 h-8 rounded-full border-2 border-white"
//               src="https://randomuser.me/api/portraits/men/32.jpg"
//               alt="User 2"
//             />
//             <img
//               className="w-8 h-8 rounded-full border-2 border-white"
//               src="https://randomuser.me/api/portraits/women/17.jpg"
//               alt="User 3"
//             />
//           </div>
//           {/* Text */}
//           <p className="font-semibold text-gray-700 text-sm">5M+ Active candidates</p>
//         </div>
//       </div>

//       {/* Card 2: Job Posting */}
//       <div className="text-left bg-white p-6 rounded-2xl shadow-lg border border-gray-100">
//         <h3 className="font-bold mph-primary flex items-center gap-2"><FiPlusCircle className="mph-primary" />
//          <span className='text-sm font-semibold mph-light mph-primary px-3 py-1 rounded-full'>AI Smart JD Builder</span></h3>
//         <Link
//           to="/jobs" // The path to your new page
//           className="flex gap-2 items-center bg-gradient text-white text-sm font-semibold px-4 py-2 rounded-full mt-4 hover:profiler-bg"
//           style={{ width: 'fit-content' }}>
//           <IoSparkles />
//           View All Jobs
//           <FiArrowRight />
//         </Link>
//         <p className="text-xs text-gray-500 mt-3">Create smarter, enhanced job descriptions with our AI-powered assistant and instantly post them across multiple platforms.</p>
//         <p className='text-gray-700 text-xs mt-8'>1L+ Active jobs</p>
//       </div>

//       {/* Card 3: Leadership Dashboard */}
//       <div className="text-left bg-white p-6 rounded-2xl shadow-lg border border-gray-100">
//         <h3 className="font-bold mph-primary flex items-center gap-2"><FiBarChart2 className="mph-primary" /> <span className='text-sm font-semibold mph-light mph-primary px-3 py-1 rounded-full'>Leadership Dashboard</span></h3>
//         <button className="flex gap-2 items-center bg-gradient text-white text-sm font-semibold px-4 py-2 rounded-full mt-4 hover:profiler-bg">View Analytics <FiArrowRight /></button>
//         <p className="text-xs text-gray-500 mt-3">Track your performance, team metrics, and get insights to improve your recruitment success rate.</p>
//       </div>
//     </section>
//   );
// };

// export default ActionCards;

import React from 'react';
import { FiPlusCircle, FiBarChart2, FiArrowRight, FiSearch } from 'react-icons/fi';
import { IoSparkles } from 'react-icons/io5';
import { Link } from 'react-router-dom';
 
const ActionCards = () => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-4 anim-slideDown" style={{ animationDuration: "1.5s" }}>
      {/* Card 1: Smart Candidate Search */}
      <div className="text-left bg-white pl-6 pr-6 pt-3 pb-3 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl hover:scale-105 hover:border-gray-200 transition-all duration-300 cursor-pointer">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <h3 className="font-bold mph-primary flex items-center gap-2 flex-wrap">
            <FiSearch className="mph-primary flex-shrink-0" />
            <span className='text-xs font-semibold mph-light mph-primary px-3 py-1 rounded-full'>Smart Search</span>
          </h3>
          <Link
            to="/candidates"
            className="flex gap-2 items-center bg-gradient text-white text-xs font-semibold px-4 py-2 rounded-full hover:profiler-bg whitespace-nowrap w-fit self-start lg:self-auto">
            <IoSparkles />Search Candidates<FiArrowRight />
          </Link>
        </div>
        <p className="text-xs text-gray-500 mt-3">Find the perfect candidates using AI-powered matching algorithms. Search by skills, experience, location, and more.</p>
        <div className="flex items-center gap-3 mt-2">
          <div className="flex -space-x-3">
            <img
              className="w-8 h-8 rounded-full border-2 border-white"
              src="https://randomuser.me/api/portraits/women/68.jpg"
              alt="User 1"
            />
            <img
              className="w-8 h-8 rounded-full border-2 border-white"
              src="https://randomuser.me/api/portraits/men/32.jpg"
              alt="User 2"
            />
            <img
              className="w-8 h-8 rounded-full border-2 border-white"
              src="https://randomuser.me/api/portraits/women/17.jpg"
              alt="User 3"
            />
          </div>
          <p className="font-semibold text-gray-700 text-sm">5M+ Active candidates</p>
        </div>
      </div>
 
      {/* Card 2: Job Posting */}
      <div className="text-left bg-white pl-6 pr-6 pt-6 pb-3 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl hover:scale-105 hover:border-gray-200 transition-all duration-300 cursor-pointer">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <h3 className="font-bold mph-primary flex items-center gap-2 flex-wrap">
            <IoSparkles className="mph-primary flex-shrink-0" />
            <span className='text-xs font-semibold mph-light mph-primary px-3 py-1 rounded-full'>AI Smart JD Builder</span>
          </h3>
          <Link
            to="/jobs"
            className="flex gap-2 items-center bg-gradient text-white text-xs font-semibold px-4 py-2 rounded-full hover:profiler-bg whitespace-nowrap w-fit self-start lg:self-auto">
            <IoSparkles />View All Jobs<FiArrowRight />
          </Link>
        </div>
        <p className="text-xs text-gray-500 mt-3">Create smarter, enhanced job descriptions with our AI-powered assistant and instantly post them across multiple platforms.</p>
        <div className="flex items-center gap-3 mt-2">
          <div className="flex -space-x-3"></div>
          <p className="font-semibold text-gray-700 text-sm pt-2">5k+ Active jobs</p>
        </div>
      </div>
 
      {/* Card 3: Leadership Dashboard */}
      <div className="text-left bg-white pl-6 pr-6 pt-6 pb-3 rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl hover:scale-105 hover:border-gray-200 transition-all duration-300 cursor-pointer">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <h3 className="font-bold mph-primary flex items-center gap-2 flex-wrap">
            <FiBarChart2 className="mph-primary flex-shrink-0" />
            <span className='text-xs font-semibold mph-light mph-primary px-3 py-1 rounded-full'>Leadership Dashboard</span>
          </h3>
          <button className="flex gap-2 items-center bg-gradient text-white text-xs font-semibold px-4 py-2 rounded-full hover:profiler-bg whitespace-nowrap w-fit self-start lg:self-auto">
            View Analytics<FiArrowRight />
          </button>
        </div>
        <p className="text-xs text-gray-500 mt-3">Track your performance, team metrics, and get insights to improve your recruitment success rate.</p>
      </div>
    </section>
  );
};
 
export default ActionCards;